const PERMISSION_KEY= "core:referral_rewards";
const PAGE_URL = {
    REFERRAL_REWARD_PAGE: "/admin/core/referral-reward"
}

export {PERMISSION_KEY, PAGE_URL}

